import { Directive, HostListener, Output, EventEmitter } from '@angular/core';
import { SearchToolbarComponent } from '../components/searchToolBar/search-toolbar.component';
import { SearchToolbarModel } from '../components/searchToolBar/search-toolbar.model';
import { QFilterModel } from '../../../models/qfilter.model';
import * as moment from 'moment';

/**
* Directive utilizzata come adapter per passare i parametri ai metodi di campaign/analytics
* che richiedono un oggetto di tipo "qfilter"  come parametro
*/
@Directive({
  selector: '[appQFilter]'
})
export class QfilterSearchToolbarDirective {
  @Output() onQFilter: EventEmitter<QFilterModel> = new EventEmitter<QFilterModel>();

  public static convertProductLevel(level: number): string {

    switch (level) {
      case 0:
        return 'subsettore';
      case 1:
        return 'reparto';
      case 2:
        return 'categoria';
      case 3:
        return 'subcategoria';
      case 4:
        return 'famiglia';
      case 5:
        return 'subfamiglia';
      case 6:
        return 'articolo';
    }

    return null;
  }

  constructor(
    private el: SearchToolbarComponent
  ) {

  }

  /**
   * Vrapper della onApply, utilizzato per adattare il payload al tipo "qfilter"
   *
   * @param event
   */
  @HostListener('onApply', ['$event']) onApply(event: SearchToolbarModel) {
    const filter: QFilterModel = new QFilterModel();

    filter.area = event.area == null ? null : event.area;
    filter.start_date = moment(event.elapsed_start).format('YYYY-MM-DD').toString();
    filter.end_date = moment(event.elapsed_end).format('YYYY-MM-DD').toString();
    filter.groups = event.groups == null ? null : event.groups;
    filter.group_type = event.group_type == null ? null : event.group_type;
    filter.card_mode = event.card_mode == null ? null : event.card_mode;
    filter.stores = event.stores == null ? null : event.stores;
    filter.key_code_group = event.group_type_code;
    filter.clusters = event.clusters;
    filter.product_level = event.sectors && event.sectors.depth >= 0 ? QfilterSearchToolbarDirective.convertProductLevel(event.sectors.depth) : null;
    filter.product_code = event.sectors && event.sectors.depth >= 0 ? event.sectors.sectors : null;
    filter.promo = event.promotions ? event.promotions : null;

    this.onQFilter.emit(filter);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/directives/qfilter-search-toolbar.directive.ts